'use client'

import { usePathname } from 'next/navigation'
import Link from 'next/link'
import classNames from 'classnames'
import {
  getHeaderDomain,
  getKnowledgeBankUrl,
  getServiceUrl,
  type SourcingCompany,
} from '@dustin-web/microsite-config'
import { useLayout } from '@dustin-web/microsite-components/src/hooks'
import { useI18n } from '@dustin-web/microsite-components/src/i18n'
import ProductsNav, { ProductsNavItems } from './header-products-nav'
import SolutionsNav from './header-solutions-nav'

type Props = {
  isProductOpen?: boolean
  sourcingCompany: SourcingCompany
}

const MainNav = ({ isProductOpen = false, sourcingCompany }: Props) => {
  const { translate } = useI18n()
  const { header } = useLayout()
  const pageUri = usePathname()
  const currentDomain = getHeaderDomain(pageUri ?? '', sourcingCompany)

  return (
    <ul
      className={classNames('c-header__navigation-list ul-stripped', {
        'c-header__navigation-list--active': header.isProductOpen,
      })}>
      <ProductsNav />
      <SolutionsNav />
      {/* <!-- Knowledge bank --> */}
      <li className="c-header__navigation-item">
        <Link
          prefetch={false}
          data-ga-title="knowledgebank"
          href={getKnowledgeBankUrl(sourcingCompany)}
          shallow
          className={classNames('c-header__navigation-link', {
            'c-header__navigation-link--active':
              currentDomain === 'Knowledge bank' && !isProductOpen,
          })}>
          {translate('Header_KnowledgeBank')}
        </Link>
      </li>
      {/* <!-- Customer support --> */}
      <li className="c-header__navigation-item">
        <Link
          prefetch={false}
          href={getServiceUrl(sourcingCompany)}
          shallow
          data-ga-title="customer-service"
          className={classNames('c-header__navigation-link', {
            'c-header__navigation-link--active':
              currentDomain === 'Customer service' && !isProductOpen,
          })}>
          {translate('Header_CustomerServiceSupport')}
        </Link>
      </li>
      <ul
        className={classNames(
          'c-header__navigation-list c-header__navigation-list--sub ul-stripped js-mega-menu-trigger',
          {
            'c-header__navigation-list--sub--active': header.isProductOpen,
          }
        )}>
        <ProductsNavItems />
      </ul>
    </ul>
  )
}

export default MainNav
